import {
  beAccountListUsers,
  beAccountSettingsGetUserSetting,
  beAccountSettingsUpsertUserSettings
} from 'Api/beAccountSettingsApi'
import { beAccountsApiGetUserById } from 'Api/beAccountsApi'
import {
  beBeeServiceApiAuthorizeBee,
  beBeeServiceGetContentDefaults
} from 'Api/beBeeServiceApi'
import { beEmailMessageApiListDynamicContentByIdMessage } from 'Api/beEmailMessageApi'
import { beEmailRenderingApiGeneratePreview } from 'Api/beEmailRenderingApi'
import {
  beFiltersGetAllLiquidProfileFilters,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters
} from 'Api/beFiltersApi'
import { beFormListAutoprofileForms } from 'Api/beFormApi'
import {
  beMessApiCreateMessage,
  beMessApiDeleteConcurrentAccess,
  beMessApiGetBeePluginUid,
  beMessApiGetConcurrentAccess,
  beMessApiGetDynamicContentByList,
  beMessApiUpdateMessage,
  beMessGetMessageDetails,
  beMessGetMessageMinimumDetails,
  beMessSetMessageAutoSave
} from 'Api/beMessApi'
import {
  bePersonalizationApiGetListActivation,
  bePersonalizationApiGetMessageActivation
} from 'Api/bePersonalizationApi'
import { bePubCustomListLandingPages } from 'Api/bePubCustomApi'
import {
  CHANNEL_TYPE_EMAIL,
  GROUPS_SEARCH_TYPE_ECONTAINS,
  GROUPS_SEARCH_TYPE_EQUALTO,
  SUBSCRIPTION_TYPE_SUBSCRIBED,
  beRecipientApiSearchForRecipients,
  beRecipientGetDynamicFieldsDefinition,
  beRecipientGetListOfGroupDetails
} from 'Api/beRecipientApi'
import transformations from 'Components/PreviewTool/transformations'
import { BEE_ADDONS, BEE_FONTS } from 'Constants/beeEditor'
import {
  MSG_PLACEHOLDERS_MANDATORY_SENDER_INFO,
  MSG_PLACEHOLDERS_SENDING_DATE,
  MSG_PLACEHOLDERS_SUBSCRIBER_INFO
} from 'Constants/emailPlaceholders'
import {
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  MESSAGE_AUTOSAVE_TIMEOUT,
  STORE_KEY_LIST,
  STORE_KEY_USER
} from 'Constants/index'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  evalCondition,
  getLang,
  storeGet,
  storeRemove,
  storeSet
} from 'mailup-react-helpers'
import { getAllAvailableFilterTypes } from './../../../../api/beFiltersApi'

export const STORE_KEY_TPL = 'templateLPSaved'

export const getBeeLang = (lang) => {
  switch (lang.toLowerCase()) {
    case 'en':
      return 'en-US'
    case 'ja':
      return 'ja-JP'
    case 'hi':
      return 'hi-IN'
    case 'pt':
      return 'pt-BR'
    case 'da':
      return 'da-DK'
    default:
      return `${lang.toLowerCase()}-${lang.toUpperCase()}`
  }
}

export const saveLocalTemplate = (structure) => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  storeSet(`${STORE_KEY_TPL}-${idList}`, structure)
}

export const getDefaultForm = async () => {
  const fields = {}
  const layout = []

  // CAMPI FISSI

  // email
  const emailKey = genereteKeyForJson(
    getIntl().formatMessage({ id: 'Load.Bee.FormEmailKey' })
  )
  fields[emailKey] = {
    type: 'email',
    label: getIntl().formatMessage({ id: 'Load.Bee.FormEmailLabel' }),
    attributes: {
      required: true,
      name: 'email',
      maxlength: '200'
    }
  }
  layout.push([emailKey])

  // prefisso
  const prefixKey = genereteKeyForJson(
    getIntl().formatMessage({ id: 'Load.Bee.FromPrefixKey' })
  )
  fields[prefixKey] = {
    type: 'number',
    label: getIntl().formatMessage({ id: 'Load.Bee.FromPrefixLabel' }),
    removeFromLayout: true,
    attributes: {
      required: true,
      name: 'prefix',
      placeholder: getIntl().formatMessage({
        id: 'Load.Bee.FromPrefixKeyPlaceholder'
      })
    }
  }
  layout.push([prefixKey])

  // telefono
  const phoneKey = genereteKeyForJson(
    getIntl().formatMessage({ id: 'Load.Bee.FromPhoneNumberKey' })
  )
  fields[phoneKey] = {
    type: 'tel',
    label: getIntl().formatMessage({ id: 'Load.Bee.FromPhoneNumberLabel' }),
    removeFromLayout: true,
    attributes: {
      required: true,
      name: 'number'
    }
  }
  layout.push([phoneKey])

  // privacy
  const privacyKey = genereteKeyForJson(
    getIntl().formatMessage({ id: 'Load.Bee.FromPrivacyKey' })
  )
  fields[privacyKey] = {
    type: 'checkbox',
    label: getIntl().formatMessage({ id: 'Load.Bee.FromPrivacyLabel' }),
    attributes: {
      required: true
    }
  }
  layout.push([privacyKey])

  // submit
  const submitKey = genereteKeyForJson(
    getIntl().formatMessage({ id: 'Load.Bee.FormSubmitKey' })
  )
  fields[submitKey] = {
    type: 'submit',
    attributes: {
      value: getIntl().formatMessage({ id: 'Load.Bee.FormSubmitLabel' })
    },
    canBeRemovedFromLayout: false
  }
  layout.push([submitKey])

  // campi anagrafici
  const dynamicFields = await beRecipientGetDynamicFieldsDefinition()
  const dynamicFieldsSorted = dynamicFields.sort((a, b) =>
    a.Id > b.Id ? 1 : b.Id > a.Id ? -1 : 0
  )
  dynamicFieldsSorted.forEach((d) => {
    const field = 'ID' + d.Id + '_' + genereteKeyForJson(d.Description)
    fields[field] = {
      type: 'text',
      label: d.Description,
      removeFromLayout: true,
      attributes: {
        name: 'campo' + d.Id,
        maxlength: '200'
      }
    }
    layout.push([field])
  })

  // return
  const defaultForm = {
    structure: {
      title: 'Form title',
      fields,
      layout,
      attributes: {
        action: 'subscribe.aspx'
      }
    }
  }

  return defaultForm
}

export const genereteKeyForJson = (str) => {
  return str
    .replace(/ /g, '-')
    .replace(/[^a-zA-Z ]/g, '')
    .replace('.', '')
}

export const fetchAddOns = () => {
  const intl = getIntl()
  return BEE_ADDONS.map(({ label, ctaLabel, ...addon }) => ({
    ...addon,
    label: intl.formatMessage({ id: label }),
    ctaLabel: intl.formatMessage({ id: ctaLabel })
  }))
}

export const getRoleHash = (lockContentBeeEditor, enableDisplayConditions) => {
  return lockContentBeeEditor
    ? enableDisplayConditions
      ? 'LockRowsPersonalization'
      : 'LockRows'
    : enableDisplayConditions
      ? 'Personalization'
      : 'NoLockRowsNoPersonalization'
}

export async function fetchAutoprofileForms() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const items = await beFormListAutoprofileForms(idList, {
    pageNumber: 0,
    pageSize: 0,
    enabled: true
  })

  const type = getIntl().formatMessage({
    id: 'Load.Bee.SpecialLinkTypeAutoprofileForms'
  })

  return items.Items.map(({ Id, Name }) => ({
    type,
    label: Name,
    link: `http://[autoprofile]/&idForm=${Id}`
  }))
}

export async function fetchLandingPages() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const { Guid } = storeGet(STORE_KEY_LIST)
  const { Items } = await bePubCustomListLandingPages(idList, {
    pageNumber: 0,
    pageSize: 0
  })

  const type = getIntl().formatMessage({
    id: 'Load.Bee.SpecialLinkTypeLandingPages'
  })

  return Items !== null
    ? Items.filter(({ Status }) => Status).map(({ Id, Name }) => ({
        type,
        label: Name,
        link: `http://${Domain}/frontend/LandingPage.aspx?idList=${idList}&idLP=${Id}&guid=${encodeURIComponent(
          Guid
        )}`
      }))
    : []
}

export async function fetchSpecialLinks() {
  const intl = getIntl()
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const { IdList, Guid } = storeGet(STORE_KEY_LIST)
  const commonType = intl.formatMessage({
    id: 'Load.Bee.SpecialLinkTypeCommon'
  })
  const archiveType = intl.formatMessage({
    id: 'Load.Bee.SpecialLinkTypeArchivedNewsletters'
  })

  const autoprofileForms = await fetchAutoprofileForms()
  const landingPages = await fetchLandingPages()

  return [
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkUnsubscribe' }),
      link: 'http://[unsubscribe]/'
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkConfirmSubscribe' }),
      link: 'http://[subscribelink]/'
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkPreferenceCenter' }),
      link: 'http://[prefcenter]/'
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkShowInBrowser' }),
      link: 'http://[staticnl]/'
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkSendToAFriend' }),
      link: `https://${Domain}/frontend/sendtoafriend.aspx?idNL=[_idnl]&idoptin=[_idoptin]&strHash=[_hash]`
    },
    ...autoprofileForms,
    ...landingPages,
    {
      type: archiveType,
      label: intl.formatMessage({
        id: 'Load.Bee.SpecialLinkArchivedNewsletterCatalogForCurrentList'
      }),
      link: `http://${Domain}/frontend/newsletters.aspx?idlist=${IdList}&hashlista=${encodeURIComponent(
        Guid
      )}#`
    },
    {
      type: archiveType,
      label: intl.formatMessage({
        id: 'Load.Bee.SpecialLinkArchivedNewsletterCatalogForConsole'
      }),
      link: `http://${Domain}/frontend/nl_catalog.aspx`
    }
  ]
}

export async function fetchMergeTags() {
  const fields = await beRecipientGetDynamicFieldsDefinition({
    isdynamic: true
  })

  const placeholders = [
    ...MSG_PLACEHOLDERS_MANDATORY_SENDER_INFO,
    ...MSG_PLACEHOLDERS_SENDING_DATE,
    ...MSG_PLACEHOLDERS_SUBSCRIBER_INFO
  ]

  const mergeTags = [
    ...fields
      .map(({ Description }) => Description.toLowerCase())
      .sort((a, b) => (a < b ? -1 : a > b ? 1 : 0))
      .map((f) => ({
        value: `[${f}]`,
        name: f
      })),
    ...placeholders.map((f) => ({
      value: `[${f}]`,
      name: f
    }))
  ]

  return mergeTags
}
export async function fetchDynamicContents() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beMessApiGetDynamicContentByList(idList)

  return [
    ...Items.map(({ Id, Name }) => ({
      value: `[*Cnt_${Id}_${Name}*]`,
      name: Name
    }))
  ]
}

export const sortDisplayConditions = (
  { level1Compare: l1A, level2Compare: l2A },
  { level1Compare: l1B, level2Compare: l2B }
) => {
  return l1A < l1B ? -1 : l1A > l1B ? 1 : l2A < l2B ? -1 : l2A > l2B ? 1 : 0
}

export async function fetchRowDisplayConditions() {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const items = await beFiltersGetAllLiquidProfileFilters(idList)
  const categories = await beFiltersGetListOfCategories(0, 0)
  const categoriesMap = categories.Items.reduce(
    (acc, { Id, Name }) => {
      return {
        ...acc,
        [Id]: Name
      }
    },
    { 0: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' }) }
  )

  const result = items.map(
    ({ IdCategory, Name, Description, LiquidBegin, LiquidEnd }) => ({
      type: categoriesMap[IdCategory],
      label: Name,
      description: Description,
      before: LiquidBegin,
      after: LiquidEnd,
      level1Compare:
        categoriesMap[IdCategory] && categoriesMap[IdCategory].toLowerCase(),
      level2Compare: Name.toLowerCase()
    })
  )

  return result.sort(sortDisplayConditions)
}

export const getBeePluginConfig = async () => {
  const lang = getLang()
  const language = getBeeLang(lang)

  const lockContentBeeEditor = evalCondition('uo:LOCKCONTENTBEEEDITOR')

  const enableDisplayConditions = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION'
  )

  const hasDynamicFields = evalCondition('uo:DYNFLD')

  const roleHash = getRoleHash(lockContentBeeEditor, enableDisplayConditions)

  const idList = storeGet(STORE_KEY_ID_LIST)

  const uid = await beMessApiGetBeePluginUid(idList)

  const specialLinks = await fetchSpecialLinks()

  const mergeTags = hasDynamicFields ? await fetchMergeTags() : []

  const mergeContents = hasDynamicFields ? await fetchDynamicContents() : []

  const rowDisplayConditions = enableDisplayConditions
    ? await fetchRowDisplayConditions()
    : []

  const account = storeGet(STORE_KEY_ACCOUNT)
  const beeSavedRowsEnabled = account.IdOffer !== 3 && account.IdOffer !== 8 // NON E' UNA STARTER E NON E' UNA LIGHT
  // const addOns = fetchAddOns()
  const beeConfiguration = {
    // whitelabel: true, // Not implemented yet
    // mode: 'full', // 'full|advanced|basic|view', // Not implemented yet
    // theme: 'classic', //'dark|light|classic', // Not implemented yet
    // showToolbar: true,
    // toolbar: ['Save', 'Save As Template', 'Send', 'Preview'], // Not implemented yet,
    uid,
    container: 'bee-plugin-container',
    autosave: 30, // in seconds - Utils.CInt(Utils.GetCommonSetting("NewsletterAutoSaveTimeout"), 60);
    language, // if language is not supported the defualt language is loaded (value must have two-letter ISO 639-1 code format)
    specialLinks,
    mergeTags,
    mergeContents,
    preventClose: false,
    rowDisplayConditions,
    rowsConfiguration: {
      emptyRows: true,
      defaultRows: true,
      externalContentURLs: []
    },
    contentDialog: {},
    // addOns,
    roleHash,
    editorFonts: {
      showDefaultFonts: false,
      customFonts: BEE_FONTS
    },
    saveRows: beeSavedRowsEnabled
  }

  if (beeSavedRowsEnabled) {
    beeConfiguration.rowsConfiguration.externalContentURLs.push({
      name: getIntl().formatMessage({ id: 'Load.Bee.SavedRows' }),
      value: 'category-value',
      handle: 'category-handle',
      isLocal: true,
      behaviors: {
        canEdit: true,
        canDelete: true
      }
    })
  }

  const contentDefaults = await beBeeServiceGetContentDefaults(idList)

  if (
    contentDefaults &&
    contentDefaults.Enable &&
    contentDefaults.Configuration
  ) {
    const enableObj = JSON.parse(contentDefaults.Enable)
    const configurationObj = JSON.parse(contentDefaults.Configuration)
    if (enableObj && enableObj.EnableAll && configurationObj) {
      beeConfiguration.contentDefaults = configurationObj
    }
  }

  return beeConfiguration
}

export const removeLocalTemplate = () => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  storeRemove(`${STORE_KEY_TPL}-${idList}`)
}

export const updateAutoSave = async (
  idMessage,
  { content, subject, structure }
) => {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const autosaveData = {
    Text: content || '',
    Subject: subject || '',
    Notes: '',
    PreHeader: '',
    Structure: structure
  }

  await beMessSetMessageAutoSave(idList, idMessage, autosaveData)
}
export async function getBeeToken() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const uid = await beMessApiGetBeePluginUid(idList)
  return beBeeServiceApiAuthorizeBee('message', uid)
}

export async function generatePreview(idMessage, params) {
  const res = await beEmailRenderingApiGeneratePreview(idMessage, params)
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)

  const transformedContent = transformations(res.Content)
    .replaceHref({
      '#': ['http://', `http://${Domain}`, `http://${Domain}/`]
    })
    .disablePointerEvents('a[href^="["]')
    .disablePointerEvents('a[href="#"]')
    .disablePointerEvents('a[href=""]')
    .secureBlankTargets()
    .getHtml()

  return {
    ...res,
    Content: transformedContent
  }
}

export async function getMessageDynamicContents(idMessage) {
  const results =
    await beEmailMessageApiListDynamicContentByIdMessage(idMessage)

  return results.map(({ Id, Name }) => ({ id: Id, name: Name }))
}

export async function getMessageMinimumDetails(idMessage) {
  const result = beMessGetMessageMinimumDetails(idMessage)
  return result
}

export async function getMessageDetails(idMessage) {
  const result = await beMessGetMessageDetails(idMessage)
  return result
}

export async function getListActivation() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const hasPersonalization = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION'
  )

  const result = hasPersonalization
    ? await bePersonalizationApiGetListActivation(idList)
    : { Items: [] }

  return result
}

export async function getGroups(searchBy, exact = false) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchBy,
    searchType: exact
      ? GROUPS_SEARCH_TYPE_EQUALTO
      : GROUPS_SEARCH_TYPE_ECONTAINS
  })
  return Items.map(({ Id, Name, Notes }) => ({
    label: `${Id} - ${Name}${Notes ? ' (' + Notes + ')' : ''}`,
    value: Id
  }))
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  //
  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const filters = await beFiltersGetListOfFilters(idList, {
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false,
    hidden,
    types: getAllAvailableFilterTypes()
  })

  const allFilters = filters.Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function searchRecipients(search, dynamicFields) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { pageNumber, pageSize, orderDescending } = search

  const searchParams = {
    channel: CHANNEL_TYPE_EMAIL,
    status: [SUBSCRIPTION_TYPE_SUBSCRIBED],
    pageSize,
    pageNumber,
    orderDescending,
    excludeFields: false
  }

  const searchConditions = getSearchConditions(search)

  const apiParams = new Map()
  apiParams.set('idList', idList)
  apiParams.set('searchParams', searchParams)
  apiParams.set('searchConditions', searchConditions)

  const res = await beRecipientApiSearchForRecipients(...apiParams.values())

  return {
    ...res,
    Items: res.Items.map((item) => {
      const fields = new Map().set('Email', item.Email)

      const fieldsEntries = item.Fields.filter(({ Id }) =>
        dynamicFields.find((df) => df.Id === Id)
      ).map((dynamicField) => [dynamicField.Id, dynamicField.Value])

      const allFields = fieldsEntries.reduce((acc, [fieldId, fieldValue]) => {
        const dynamicField = dynamicFields.find(
          (dynamicField) => fieldId === dynamicField.Id
        )
        return acc.set(dynamicField.Description, fieldValue)
      }, fields)

      return {
        id: item.Id,
        fields: allFields,
        fieldsEntries
      }
    })
  }
}

const getSearchConditions = (search) => {
  const {
    channel,
    email,
    includeGroups,
    applyFilters,
    applyFiltersOr,
    optOutTypeEmail,
    optOutTypeSms,
    optOutMessage
  } = search

  return {
    IncludeGroups: [...includeGroups],
    MatchingFilters: applyFilters.length
      ? {
          Condition: applyFiltersOr,
          Filters: [...applyFilters]
        }
      : undefined,
    UnsubscriptionType:
      channel === 'email' ? `${optOutTypeEmail}` : `${optOutTypeSms}`,
    UnsubscriptionMessage: channel === 'email' ? optOutMessage : undefined,
    Email: email,
    EmailMatchType: 'CONTAINS'
  }
}

export async function getPreviewReferenceRecipient(idList) {
  const result = await beAccountSettingsGetUserSetting(
    idList,
    'previewReferenceRecipient'
  )

  if (result && result.DataValue) {
    return JSON.parse(result.DataValue)
  }

  return {}
}

export async function listUsers() {
  const result = await beAccountListUsers({
    isActive: true,
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'login'
  })

  return result
}

export async function getMessageActivation(idMessage) {
  const hasPersonalization = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION'
  )

  const result = hasPersonalization
    ? await bePersonalizationApiGetMessageActivation(idMessage)
    : { Items: [] }

  return result
}

export function updatePreviewReferenceRecipient(dataValue) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  return beAccountSettingsUpsertUserSettings(
    idList,
    'previewReferenceRecipient',
    dataValue
  )
}

export async function createMessage(subject, structure, content) {
  const checkLiquid = evalCondition(
    'NOT co:ADVPERSONALIZATION AND co:PERSONALIZATION'
  )
  const idPersonalContent = null
  const idList = storeGet(STORE_KEY_ID_LIST)

  const message = {
    Subject: subject,
    PreHeader: '',
    Notes: '',
    Structure: structure,
    Content: content,
    IdList: idList,
    Embed: false,
    IsConfirmation: false,
    IsArchived: false,
    ShowOnline: false,
    UseDynamicField: true,
    Tags: [],
    Fields: [],
    TrackingInfo: {
      Enabled: true,
      Protocols: ['http:', 'https:', 'ftp:', 'news:'],
      CustomParams: ''
    }
  }

  const result = await beMessApiCreateMessage(message, {
    checkLiquid,
    idPersonalContent
  })

  return result
}

export async function updateBeeMessage(idMessage, { Content, Structure }) {
  const checkLiquid = evalCondition(
    'NOT co:ADVPERSONALIZATION AND co:PERSONALIZATION'
  )
  const idPersonalContent = null

  const prev = await beMessGetMessageDetails(idMessage)

  const result = await beMessApiUpdateMessage(
    idMessage,
    {
      ...prev,
      Content,
      Structure
    },
    {
      checkLiquid,
      idPersonalContent
    }
  )

  return result
}

export async function getThirdPartyAccepted() {
  const result = await beAccountSettingsGetUserSetting(
    0,
    'thirdPartyResourceAlert'
  )
  return result && result.DataValue === '1'
}

export async function getConcurrentAccessUser(idMessage) {
  if (parseInt(idMessage) === 0) {
    return undefined
  }

  const users = await beMessApiGetConcurrentAccess(
    idMessage,
    MESSAGE_AUTOSAVE_TIMEOUT
  )

  const { Id: idCurrentUser } = storeGet(STORE_KEY_USER)
  const others = users.filter(({ IdUser }) => IdUser !== idCurrentUser)

  if (!others.length) {
    return undefined
  }

  const { Username } = await beAccountsApiGetUserById(others[0].IdUser)

  return Username
}

export async function setThirdPartyResourceAlert() {
  try {
    const result = await beAccountSettingsUpsertUserSettings(
      0,
      'thirdPartyResourceAlert',
      1
    )
    return !result || result.DataValue !== '1'
  } catch (error) {
    logAppError({
      appError: error
    })
  }
}

export async function deleteConcurrentAccess(idMessage) {
  if (parseInt(idMessage) === 0) {
    return true
  }

  const result = await beMessApiDeleteConcurrentAccess(idMessage)
  return result
}
